var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderComponent'),_c('div',{staticClass:"clear"}),_vm._t("default"),_c('div',{staticClass:"clear"}),_c('FooterComponent')],2)}
var staticRenderFns = []

export { render, staticRenderFns }